import type { Config } from '@grandvisionhq/shipping'

export const getDeliveryIndicatorConfig = (): Config => ({
  inventoryChannels: {
    // There is a bug in using the key as the cart does not return inventory channel keys.
    // test
    '583774ca-7dda-43c4-8a9c-3242bd7b0e82': {
      expectedDeliveryDays: {
        onStock: '36-72 horas',
        outOfStock: '5-8 días',
      },
    },
    // acc
    'f690865c-a627-42d8-aba2-41d103e377d9': {
      expectedDeliveryDays: {
        onStock: '36-72 horas',
        outOfStock: '5-8 días',
      },
    },
    // prod
    '9cc504a1-0d8e-4b33-9de7-1667f9a2addf': {
      expectedDeliveryDays: {
        onStock: '36-72 horas',
        outOfStock: '5-8 días',
      },
    },
  },
  missingInventoryChannelStrategy: {
    expectedDeliveryDays: '5-8 días',
  },
  nextDayDeliveryTimeLimit: '17:30',
})
